/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceStatRow } from './AttendanceStatRow';
import {
    AttendanceStatRowFromJSON,
    AttendanceStatRowFromJSONTyped,
    AttendanceStatRowToJSON,
    AttendanceStatRowToJSONTyped,
} from './AttendanceStatRow';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AttendanceWidgetData
 */
export interface AttendanceWidgetData {
    /**
     * 
     * @type {Array<AttendanceStatRow>}
     * @memberof AttendanceWidgetData
     */
    items: Array<AttendanceStatRow>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AttendanceWidgetData
     */
    total: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the AttendanceWidgetData interface.
 */
export function instanceOfAttendanceWidgetData(value: object): value is AttendanceWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function AttendanceWidgetDataFromJSON(json: any): AttendanceWidgetData {
    return AttendanceWidgetDataFromJSONTyped(json, false);
}

export function AttendanceWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AttendanceStatRowFromJSON)),
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
    };
}

export function AttendanceWidgetDataToJSON(json: any): AttendanceWidgetData {
    return AttendanceWidgetDataToJSONTyped(json, false);
}

export function AttendanceWidgetDataToJSONTyped(value?: AttendanceWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(AttendanceStatRowToJSON)),
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
    };
}

